import {
  FiActivity,
  FiAward,
  FiBookOpen,
  FiClock,
  FiCoffee,
  FiCompass,
  FiHeart,
  FiHome,
  FiMonitor,
  FiShield,
  FiSun,
  FiUsers,
} from "react-icons/fi";

export const trustMarkers = [
  { icon: FiAward, value: "75+ Years", label: "Of global legacy" },
  { icon: FiShield, value: "Safe & nurturing", label: "Residential community" },
  { icon: FiBookOpen, value: "Academic excellence", label: "With holistic development" },
  { icon: FiActivity, value: "Sports, arts & nature", label: "And life skills" },
  { icon: FiUsers, value: "A supportive home", label: "Away from home" },
];

export const whyBoarding = [
  {
    icon: FiSun,
    title: "Healthy surroundings",
    text: "A green hill campus with space to learn, move and breathe.",
  },
  {
    icon: FiUsers,
    title: "A close-knit community",
    text: "Students learn independence while being supported by caring adults.",
  },
  {
    icon: FiMonitor,
    title: "Learning with purpose",
    text: "Smart classrooms, support sessions, Robotics and the ATL lab enrich learning.",
  },
  {
    icon: FiHeart,
    title: "Whole-child development",
    text: "Academics, values, sport, creativity and well-being are part of everyday life.",
  },
];

export const boardingGallery = [
  {
    image: require("../../image/boarding/boarding display pic.webp"),
    title: "Boarding community",
    alt: "HGS Bhimtal boarding students on campus",
  },
  {
    image: require("../../image/boarding/1.jpg"),
    title: "Comfortable rooms",
    alt: "Boarding room and study desks at HGS Bhimtal",
  },
  {
    image: require("../../image/boarding/2.jpg"),
    title: "Supported study",
    alt: "Boarding students studying together",
  },
  {
    image: require("../../image/infrastructure/studentMess.jpg"),
    title: "Shared meals",
    alt: "Student dining facility at HGS Bhimtal",
  },
  {
    image: require("../../image/boarding/3.jpeg"),
    title: "Sport & recreation",
    alt: "Students playing basketball on the HGS Bhimtal campus",
  },
];

export const dailyRhythm = [
  { icon: FiSun, time: "6:00 AM", label: "Wake up & morning routine" },
  { icon: FiBookOpen, time: "8:00 AM", label: "Classes" },
  { icon: FiCoffee, time: "2:00 PM", label: "Lunch & recreation" },
  { icon: FiActivity, time: "4:00 PM", label: "Sports & activities" },
  { icon: FiMonitor, time: "6:00 PM", label: "Guided study" },
  { icon: FiCoffee, time: "8:00 PM", label: "Dinner & community" },
  { icon: FiClock, time: "10:00 PM", label: "Lights out" },
];

export const growthPillars = [
  { icon: FiBookOpen, title: "Academics", text: "Strong foundations and individual support" },
  { icon: FiHome, title: "Life skills", text: "Responsibility, routines and independence" },
  { icon: FiActivity, title: "Sports & arts", text: "Space to discover and nurture talent" },
  { icon: FiHeart, title: "Well-being", text: "A caring environment where children feel known" },
  { icon: FiUsers, title: "Leadership", text: "Teamwork, confidence and service" },
];

export const carePoints = [
  { icon: FiUsers, label: "Experienced residential staff" },
  { icon: FiShield, label: "CCTV-monitored premises" },
  { icon: FiHeart, label: "Medical support" },
  { icon: FiCoffee, label: "Balanced daily meals" },
  { icon: FiHome, label: "Structured routines" },
  { icon: FiCompass, label: "Weekend activities & outings" },
];

export const academicPoints = [
  { icon: FiMonitor, label: "Smart classrooms" },
  { icon: FiBookOpen, label: "Academic support sessions" },
  { icon: FiCompass, label: "Robotics & ATL lab" },
  { icon: FiActivity, label: "Clubs, NCC & sports" },
];

export const admissionSteps = [
  { number: "01", title: "Enquire", text: "Share your child’s details with our admissions team." },
  { number: "02", title: "Connect", text: "Discuss availability, schooling needs and boarding options." },
  { number: "03", title: "Assessment", text: "Complete the applicable interaction or entrance process." },
  { number: "04", title: "Confirm", text: "Submit documents and fees within the communicated timeline." },
];

export const faqs = [
  {
    question: "How are admissions decided?",
    answer:
      "Admissions are subject to seat availability and the applicable interaction or entrance process. Entrance performance is considered from Grade IX onwards; Pre-Nursery and Nursery do not require a test or interview.",
  },
  {
    question: "Which documents are generally required?",
    answer:
      "Families should keep the birth certificate, previous school transfer certificate and report card, photographs, address and identity proofs, medical certificate, and applicable category certificates ready. Additional board documents may be needed for Classes X and XII.",
  },
  {
    question: "Can a transfer case be considered during the session?",
    answer:
      "Transfer cases from another state may be considered during the running session when a seat is available and the required school or board documents are produced.",
  },
  {
    question: "What support do boarders receive after class?",
    answer:
      "The residential programme combines guided study, extra academic support where needed, sport and recreation, balanced meals, supervised routines and access to trained staff.",
  },
  {
    question: "How can parents learn more before applying?",
    answer:
      "Submit the enquiry form, call the admissions team, or book a campus visit. A visit is the best way to see the classrooms, boarding spaces and daily environment first-hand.",
  },
  {
    question: "Are admissions open throughout the year?",
    answer:
      "Regular admissions depend on vacancies and normally close by 31 August. Transfer cases may be considered later, subject to availability and applicable rules.",
  },
];
